import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import {
  PoBreadcrumb,
  PoPageAction,
  PoPageFilter,
  PoPageListComponent,
  PoTableAction,
  PoTableColumn,
  PoTableColumnSpacing,
  PoTableComponent,
  PoDialogService,
  PoModalComponent
} from '@po-ui/ng-components';
import { SchemaBuilderService } from '../../core/menu/schema-builder.service';
import { environment } from '../../../environments/environment';
import { ShortcutService } from '../../core/shortcut/shortcut.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-acesso',
  templateUrl: './acesso.component.html',
  styleUrl: './acesso.component.css',
  standalone: false
})
export class AcessoComponent implements OnInit, OnDestroy {

  @ViewChild('dynamicTable', { static: true }) dynamicTable!: PoTableComponent;
  @ViewChild('pageListComponent', { static: true }) pageListComponent!: PoPageListComponent;
  @ViewChild('modalAccessLogs') modalAccessLogs!: PoModalComponent;

  loading = false;
  editClient: any;
  isHideLoading = true;
  isHideLoadingAccessLogs = true;
  items: any[] = [];
  columns: Array<PoTableColumn> = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;
  moreItens: boolean = false;
  page: number = 1;
  pageSize: number = 100;
  filter: string = '';
  disclaimerGroup: any;
  private disclaimers: any[] = [];
  private shortcutSubscription!: Subscription;

  selectedUser: any = null;
  accessLogs: any[] = [];
  accessLogsPage: number = 1;
  accessLogsPageSize: number = 50;
  accessLogsHasMore: boolean = false;
  accessLogsUserId: string = ''; // Armazena o userId para próximas requisições
  accessLogDateRange: any = null; // Armazena o período de data selecionado para filtrar os logs
  public readonly filterSettings: PoPageFilter = {
    action: this.filterAction.bind(this),
    placeholder: 'Pesquisar'
  };
  readonly serviceApi = environment.apiUrl + '/v1/access';

  readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Controle de Acesso' }, { label: 'Usuários' }]
  };

  readonly pageActions: Array<PoPageAction> = [
    {
      label: 'Novo Acesso',
      action: () => this.router.navigate(['/access-edit']),
      icon: 'an an-plus'
    },
    {
      label: 'Atualizar',
      action: () => this.resetTable(),
      icon: 'an an-arrows-clockwise'
    }
  ];

  readonly actions: PoTableAction[] = [
    {
      label: 'Editar Registro',
      action: this.edit.bind(this),
      icon: 'an an-pencil',
      type: 'default'
    },
    {
      label: 'Deletar Registro',
      action: this.confirmDelete.bind(this),
      icon: 'an an-trash',
      type: 'danger',
      separator: true
    },
    {
      label: 'Registro de Acesso',
      action: this.registerAccess.bind(this),
      icon: 'po-icon po-icon-list',
      type: 'default',
      separator: true
    },
    {
      label: 'Visualizar Detalhes',
      icon: 'po-icon po-icon-eye',
      //action: this.onClickPecaDetail.bind(this),
    }
  ];

  readonly accessLogsTableColumns: Array<PoTableColumn> = [
    { property: 'accessDate', label: 'Data/Hora', width: '20%' },
    { property: 'userName', label: 'Usuário', width: '25%' },
    { property: 'userTag', label: 'TAG', width: '15%' },
    { property: 'autorizado', label: 'Autorizado', width: '15%' },
    { property: 'sala', label: 'Sala', width: '25%' }
  ];

  constructor(private readonly schemaBuilderService: SchemaBuilderService,
    private readonly route: ActivatedRoute,
    private readonly poDialogService: PoDialogService,
    private readonly shortcutService: ShortcutService,
    private readonly router: Router,
    private readonly http: HttpClient,
    private readonly cdr: ChangeDetectorRef) {
    this.schemaBuilderService.getTableSchema('access').subscribe(data => {
      this.columns = data as any;
    });
    this.shortcutSubscription = this.shortcutService.getShortcuts().subscribe((event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'b') {
        event.preventDefault();
        this.router.navigate(['/access-edit']);
      } else if (event.ctrlKey && event.key === 'f') {
        event.preventDefault();
        this.pageListComponent.filterInput.nativeElement.focus();
      }
    });
  }

  ngOnInit(): void {
    this.disclaimerGroup = {
      title: 'Filtros:',
      disclaimers: [],
      change: this.onChangeDisclaimer.bind(this),
      remove: this.onClearDisclaimer.bind(this)
    };
    this.loadMore();
  }

  ngOnDestroy(): void {
    if (this.shortcutSubscription) {
      this.shortcutSubscription.unsubscribe();
    }
  }

  populateDisclaimers(filters: Array<any>) {
    const property = filters.length > 1 ? 'advanced' : 'search';
    this.disclaimers = filters.map(value => ({ value, property }));

    if (this.disclaimers && this.disclaimers.length > 0) {
      this.disclaimerGroup.disclaimers = [...this.disclaimers];
    } else {
      this.disclaimerGroup.disclaimers = [];
    }
  }

  filterAction(labelFilter: string | Array<string>) {
    const filter = typeof labelFilter === 'string' ? [labelFilter] : [...labelFilter];
    this.populateDisclaimers(filter);
    this.filter = filter.toString();
    this.loadMore(true);
  }

  confirmDelete(item: any) {
    this.poDialogService.confirm({
      title: 'Exclus\u00e3o de Registros',
      message: `Deseja realmente excluir o item selecionado?`,
      confirm: () => this.remove(item)
    });
  }

  remove(item: any) {
    this.isHideLoading = false;
    this.http.delete(`${this.serviceApi}/${item.id}`).subscribe(() => {
      this.dynamicTable.removeItem(item);
      this.isHideLoading = true;
    }, () => {
      this.isHideLoading = true;
    });
  }

  edit(item: any) {
    this.router.navigate(['/access-edit', item.id]);
  }

  resetTable() {
    this.loadMore(true);
  }

  onChangeDisclaimer(disclaimers: any) {
    this.disclaimers = disclaimers;
    this.loadMore(true);
  }

  onClearDisclaimer(disclaimers: any) {
    if (disclaimers.removedDisclaimer.property === 'search') {
      this.pageListComponent.clearInputSearch();
    }
    this.disclaimers = [];
    this.filter = '';
    this.loadMore(true);
  }

  loadMore(reset: boolean = false): void {
    this.isHideLoading = false;
    if (reset) {
      this.page = 1;
      this.http.get<any>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&search=${this.filter}`).subscribe((data) => {
        this.items = [];
        this.items = [...this.items, ...data.items];
        this.moreItens = data.hasNext;
        this.page++;
        this.isHideLoading = true;
      }, () => {
        this.isHideLoading = true;
      });
    } else {
      this.http.get<any>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&search=${this.filter}`).subscribe((data) => {
        this.items = [...this.items, ...data.items];
        this.moreItens = data.hasNext;
        this.page++;
        this.isHideLoading = true;
      }, () => {
        this.isHideLoading = true;
      });
    }

  }

  registerAccess(item: any) {
    this.selectedUser = item;
    // Reseta tudo para garantir paginação limpa
    this.accessLogs = [];
    this.accessLogsPage = 1;
    this.accessLogsHasMore = false;
    this.accessLogsUserId = '';
    this.isHideLoadingAccessLogs = false;
    this.modalAccessLogs.open();
    // Carrega os logs após abrir o modal
    this.loadAccessLogs(item, true);
  }

  loadAccessLogs(user: any, reset: boolean = true) {
    this.isHideLoadingAccessLogs = false;

    // Se for reset, limpa tudo e reinicia a paginação
    if (reset) {
      this.accessLogs = [];
      this.accessLogsPage = 1;
      this.accessLogsHasMore = false;
      this.accessLogsUserId = '';
      this.accessLogDateRange = null;
    }

    // Verifica se o usuário tem userAccessId ou id
    // O item da tabela de acesso tem o campo 'id' que é o userAccessId
    const userId = user?.userAccessId || user?.id || user?.Id || user?.UserAccessId;

    console.log('Item selecionado:', user);
    console.log('UserID extraído:', userId);

    if (!userId) {
      this.poDialogService.alert({
        title: 'Aviso',
        message: 'Este registro não possui um ID de acesso válido.'
      });
      this.isHideLoadingAccessLogs = true;
      return;
    }

    // Armazena o userId para próximas requisições
    if (!this.accessLogsUserId) {
      this.accessLogsUserId = userId;
    }

    // Se já temos o userId e não é reset, faz a requisição diretamente
    if (this.accessLogsUserId && !reset) {
      this.loadMoreAccessLogs();
      return;
    }

    // Busca os logs de acesso usando o userId com paginação
    this.loadMoreAccessLogs();
  }

  loadMoreAccessLogs() {
    if (!this.accessLogsUserId) {
      this.isHideLoadingAccessLogs = true;
      return;
    }

    this.isHideLoadingAccessLogs = false;

    console.log('Carregando página:', this.accessLogsPage, 'com', this.accessLogsPageSize, 'itens');

    // Formata as datas se houver período selecionado
    let startDate: string | undefined;
    let endDate: string | undefined;

    if (this.accessLogDateRange && this.accessLogDateRange.start && this.accessLogDateRange.end) {
      startDate = this.formatDateForAPI(this.accessLogDateRange.start);
      endDate = this.formatDateForAPI(this.accessLogDateRange.end);
    }

    // Busca os logs de acesso usando o userId com paginação
    let apiUrl = `${environment.apiUrl}/v1/access/log-access/user/${this.accessLogsUserId}?page=${this.accessLogsPage}&pageSize=${this.accessLogsPageSize}`;
    if (startDate) {
      apiUrl += `&startDate=${encodeURIComponent(startDate)}`;
    }
    if (endDate) {
      apiUrl += `&endDate=${encodeURIComponent(endDate)}`;
    }
    console.log('URL da API:', apiUrl);

    this.http.get<any>(apiUrl).subscribe({
      next: (response) => {
        console.log('Resposta da API de logs:', response);

        // Verifica se a resposta tem estrutura paginada
        const logsData = response.items || response.data || (Array.isArray(response) ? response : []);

        // Determina se há mais itens
        let hasNext = false;
        if (response.hasNext !== undefined) {
          hasNext = response.hasNext;
        } else if (Array.isArray(response)) {
          // Se for array direto, verifica se tem mais itens
          hasNext = response.length === this.accessLogsPageSize;
        } else if (response.items) {
          // Se tiver items, verifica se retornou o pageSize completo
          hasNext = response.items.length === this.accessLogsPageSize;
        }

        console.log('Logs recebidos nesta página:', logsData.length);
        console.log('Tem mais itens?', hasNext);
        console.log('Página atual (antes do incremento):', this.accessLogsPage);

        // Mapeia os logs recebidos
        const mappedLogs = (logsData || []).map((log: any) => ({
          userName: log.userName || 'N/A',
          userTag: log.tag || 'N/A',
          autorizado: log.isAuthorized === true ? 'Sim' : 'Não',
          sala: log.roomAlias || 'N/A',
          accessDate: this.formatAccessDate(log.accessDate)
        }));

        // Se a API retornou mais itens que o pageSize, pega apenas os primeiros pageSize
        // Isso garante que mesmo se a API não paginar corretamente, só mostramos 8 por vez
        const logsToAdd = mappedLogs.slice(0, this.accessLogsPageSize);

        console.log('Logs que serão adicionados (limitado a', this.accessLogsPageSize, '):', logsToAdd.length);

        // Adiciona os novos logs ao array existente (não substitui, adiciona)
        this.accessLogs = [...this.accessLogs, ...logsToAdd];

        // Atualiza o controle de paginação
        // Se a API retornou mais itens que o pageSize, significa que há mais dados
        // ou se o hasNext já estava definido, usa esse valor
        if (mappedLogs.length > this.accessLogsPageSize) {
          this.accessLogsHasMore = true;
        } else {
          this.accessLogsHasMore = hasNext;
        }

        // Incrementa a página APENAS se houver mais itens para carregar
        if (this.accessLogsHasMore) {
          this.accessLogsPage++;
        }

        console.log('Total de logs exibidos agora:', this.accessLogs.length);
        console.log('Próxima página será:', this.accessLogsPage);
        console.log('Ainda tem mais?', this.accessLogsHasMore);

        // Força a detecção de mudanças múltiplas vezes para garantir que a tabela seja renderizada
        this.cdr.markForCheck();
        setTimeout(() => {
          this.cdr.detectChanges();
          // Força novamente após um pequeno delay para garantir renderização
          setTimeout(() => {
            this.cdr.detectChanges();
            // Só esconde o loading após garantir que a tabela foi renderizada
            this.isHideLoadingAccessLogs = true;
            this.cdr.detectChanges();
          }, 100);
        }, 100);
      },
      error: (err) => {
        console.error('Erro ao buscar logs:', err);
        console.error('Status:', err.status);
        console.error('Mensagem:', err.message);
        console.error('Erro completo:', err);
        this.isHideLoadingAccessLogs = true;
        this.accessLogs = [];
        this.poDialogService.alert({
          title: 'Erro',
          message: err.error?.message || err.message || 'Não foi possível carregar os registros de acesso.'
        });
      }
    });
  }

  get modalAccessLogsTitle(): string {
    const userName = this.selectedUser?.userName || this.selectedUser?.name || this.selectedUser?.tag || '';
    if (userName) {
      return `Registro de Acesso - ${userName}`;
    }
    return 'Registro de Acesso';
  }

  private formatAccessDate(date: string | Date): string {
    if (!date) return 'N/A';
    try {
      const d = typeof date === 'string' ? new Date(date) : date;
      return d.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    } catch {
      return String(date);
    }
  }

  private formatAccessType(isAuthorized: boolean): string {
    return isAuthorized ? 'Autorizado' : 'Negado';
  }

  onAccessLogDateRangeChange() {
    // Quando o filtro de data mudar, reseta a página e recarrega os logs
    this.accessLogs = [];
    this.accessLogsPage = 1;
    this.accessLogsHasMore = false;
    this.loadMoreAccessLogs();
  }

  clearAccessLogDateFilter() {
    // Limpa o filtro de data e recarrega os logs sem filtro
    this.accessLogDateRange = null;
    this.accessLogs = [];
    this.accessLogsPage = 1;
    this.accessLogsHasMore = false;
    this.loadMoreAccessLogs();
  }

  private formatDateForAPI(date: Date | string): string {
    if (!date) return '';
    try {
      const d = typeof date === 'string' ? new Date(date) : date;
      // Formata como YYYY-MM-DD para o endpoint
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    } catch {
      return '';
    }
  }

}
